import MinusIcon from "@/components/icons/MinusIcon";
import AddIcon from "@/components/icons/AddIcon";
import { useRouter } from "next/router";
import { useSession } from "next-auth/react";
import { useContext } from "react";
import { ModalContext } from "@/pages/_app";
import Link from "next/link";

const UsefulLinks = ({ t, active, setActive }) => {
  const { push } = useRouter();
  const { data: session } = useSession();
  const Context = useContext(ModalContext);
  return (
    <div className="col-span-full md:col-span-6 lg:col-span-2">
      <h2 className="hidden font-bold uppercase whitespace-nowrap md:block">
        {t("Useful Links")}
      </h2>
      <div
        onClick={() =>
          setActive(active === "useful-links" ? null : "useful-links")
        }
        className="flex items-center justify-between text-white cursor-pointer md:hidden"
      >
        <h2 className="font-bold uppercase whitespace-nowrap">
          {t("Useful Links")}
        </h2>
        {!active || active !== "useful-links" ? (
          <AddIcon className="size-3" />
        ) : (
          <MinusIcon className="size-3" />
        )}
      </div>
      <div
        className={`${
          active !== "useful-links" ? "hidden" : "flex"
        } mt-3 md:flex flex-col md:mt-6 max-sm:*:mb-3 *:mb-2 last:*:mb-0`}
      >
        <p
          onClick={() => Context?.dispatch({ type: "auth" })}
          className="cursor-pointer whitespace-nowrap"
        >
          {t("Sign in / Register")}
        </p>
        <p
          onClick={() =>
            !session?.user ? Context?.dispatch({ type: "auth" }) : push("/user")
          }
          className="cursor-pointer whitespace-nowrap"
        >
          {t("My Account")}
        </p>
        <Link
          prefetch={false}
          href="/user/favourite"
          className="whitespace-nowrap"
        >
          {t("Wishlists")}
        </Link>
        <Link prefetch={false} href="/cart" className="whitespace-nowrap">
          {t("My Cart")}
        </Link>
        <p
          onClick={() =>
            !session?.user
              ? Context?.dispatch({ type: "auth" })
              : push("/user/orders")
          }
          className="cursor-pointer whitespace-nowrap"
        >
          {t("My Orders")}
        </p>
      </div>
    </div>
  );
};

export default UsefulLinks;
